// Keep numeric keypad entry inside its card; Save remains an explicit action.
export function advanceNumericEntry(event) {
  if (event.key !== 'Enter' || event.nativeEvent?.isComposing || event.isComposing) return;
  event.preventDefault();
  if (event.repeat || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
  const current = event.currentTarget;
  if (!current.checkValidity()) {
    current.reportValidity();
    return;
  }
  const table = current.closest('table');
  if (!table) return;
  const entries = [...table.querySelectorAll('input[data-numeric-entry="true"]')].filter(input =>
    !input.matches(':disabled') && !input.readOnly && input.tabIndex >= 0 &&
    !input.closest('[hidden], [inert], [aria-hidden="true"]') &&
    input.getClientRects().length > 0 && getComputedStyle(input).visibility === 'visible'
  );
  const index = entries.indexOf(current);
  if (index >= 0 && index + 1 < entries.length) entries[index + 1].focus();
}
